import React from "react";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";
import AdminTopNav from "components/navigations/AdminNavs/AdminTopNav";
import AdminSideRecruiterNav from "components/navigations/AdminNavs/AdminSideRecruiterNav";
import AdminTopClientNav from "components/navigations/AdminNavs/AdminTopClientNav";
import EmployerMainNav from "components/navigations/EmployerNavs/EmployerMainNav";
import RecruiterTopNav from "components/navigations/RecruiterTopNav";
import RecruiterClusterNav from "components/navigations/RecruiterNavs/RecruiterClusterNav";
import ErrorPage from "pages/ErrorPage/ErrorPage";

export default function ClientLayerBlueprint(WrappedComponent) {
  return function ClientLayerComponent(props) {
    const appContext = useAppContext();
    const { account } = appContext;
    const { accountType } = account;

    if (accountType.type === ACCOUNT_TYPES.ADMIN.type) {
      return (
        <div className="min-h-screen max-h-screen">
          <AdminTopNav />
          <AdminSideRecruiterNav />
          <AdminTopClientNav />
          <section className="relative top-[110px] left-[250px]" style={{ width: "calc(100% - 250px)" }}>
            <WrappedComponent {...props} />
          </section>
        </div>
      );
    } else if (accountType.type === ACCOUNT_TYPES.RECRUITER.type) {
      return (
        <div className="min-h-screen max-h-screen">
          <RecruiterTopNav />
          <RecruiterClusterNav />
          <section className="relative top-[50px]">
            <WrappedComponent {...props} />
          </section>
        </div>
      );
    } else if (accountType.type === ACCOUNT_TYPES.EMPLOYER_PRIVATE.type) {
      return (
        <div className="min-h-screen max-h-screen">
          <EmployerMainNav />
          <section className="relative top-[50px]">
            <h2>Employer Wrapper</h2>
            <WrappedComponent {...props} />
          </section>
        </div>
      );
    } else if (accountType.type === ACCOUNT_TYPES.EMPLOYER_PUBLIC.type) {
      return (
        <div className="min-h-screen max-h-screen">
          <EmployerMainNav />
          <section className="relative top-[50px]">
            <WrappedComponent {...props} />
          </section>
        </div>
      );
    } else return <ErrorPage />;
  };
}
